export default "__VITE_ASSET__BLRduWy7__"